import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class CapacitorService {
  get android() {
    return this.platform === 'android';
  }

  get ios() {
    return this.platform === 'ios';
  }

  get mobile() {
    return this.android || this.ios;
  }

  get platform() {
    return Capacitor.getPlatform();
  }

  get web() {
    return this.platform === 'web';
  }
}
